var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    {
      attrs: { flat: "", small: "", color: "negative", disable: _vm.readonly },
      on: {
        click: function($event) {
          return _vm.handleDelete(_vm.id)
        }
      }
    },
    [_c("q-icon", { attrs: { name: "delete", color: "negative" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }